{
  "acceptedFileFormats": "Apenas ficheiros .docx, .pdf, .txt são aceites.",
  "actionCompetenceGroup": "Grupo de Competências da Ação",
  "actionDeadline": "Prazo da Ação",
  "actionDescription": "Descrição da Ação",
  "actionDuration": "Duração da Ação",
  "actionEarliestStart": "Início Mais Cedo da Ação",
  "actionName": "Nome da Ação",
  "actions": "Ações",
  "actionsAndProjects": "Ações e Projetos",
  "actionsColon": "Ações: ",
  "actionsPerformerConstraints": "Restrições de Executor de Ações",
  "add": "Adicionar",
  "addAdmin": "Adicionar Administrador",
  "addAdminTitle": "Adicionar Administrador",
  "addAnalyses": "Adicionar análises",
  "addAnalysis": "Adicionar Análise",
  "addAnalysisGroup": "Adicionar um grupo de análise",
  "addChatbot": "Adicionar chatbot",
  "addCompetenceGroup": "Adicionar Grupo de Competências",
  "addConstraint": "Adicionar restrição",
  "addGreyTask": "Adicionar uma Tarefa Cinza",
  "addInstrument": "Adicionar um Instrumento",
  "addItemPlaceholder": "Adicionar {{item}}...",
  "addLocation": "Adicionar localização",
  "addMaintenance": "Adicionar manutenção",
  "addMember": "Adicionar membro",
  "addNewBundle": "Adicionar Novo Pacote",
  "addNewMaintenanceFor": "Adicionar nova manutenção para {{assetName}}",
  "addNewTask": "Adicionar uma nova tarefa",
  "addOffsite": "Adicionar FORA DO LOCAL",
  "addProjectGroup": "Adicionar um grupo de projetos",
  "addProjectTemplate": "Adicionar Modelo de Projeto",
  "addRepository": "Adicionar repositório",
  "addRow": "Adicionar Linha",
  "addSample": "Adicionar amostra",
  "addSamples": "Adicionar amostras",
  "addTeam": "Adicionar equipa",
  "additionalInformation": "Informação Adicional",
  "administrators": "Administradores",
  "advanced": "Avançado",
  "allFilesProcessed": "Todos os ficheiros enviados foram processados",
  "allowMembersMoveOthersOperationalTasks": "Permitir que os membros movam tarefas operacionais de outros",
  "allowedCompetenceGroups": "Grupos de Competências Permitidos",
  "allowedInstruments": "Instrumentos permitidos",
  "amountOfSamples": "Quantidade de amostras: {{count}}",
  "analyses": "Análises",
  "analysesRelatedTo": "Análises relacionadas com {{product}}",
  "analysis": "Análise",
  "analysisAndSampleDone": "A análise e a amostra estão concluídas",
  "analysisDefinition": "definição de análise",
  "analysisDesignTool": "Ferramenta de Design de Análise",
  "analysisDone": "A análise está concluída",
  "analysisDraft": "RASCUNHO de Análise",
  "analysisGroup": "Grupo de análise",
  "analysisGroupName": "Nome do Grupo de Análise",
  "analysisIsFlagged": "A análise está assinalada",
  "analysisMustContainTaskDefinition": "A análise deve conter uma definição de tarefa",
  "analysisName": "Nome da Análise",
  "analysisNameMustBeUnique": "O Nome da Análise deve ser único",
  "analysisNotPlanned": "Esta análise não está planeada",
  "analysisPlanned": "A análise está planeada",
  "analysisTaskBundle": "Pacote de Tarefa de Análise {{index}}",
  "cdmoTargetedBundle": "Agrupar tarefas por nome de análise",
  "analysisTaskTimePerformerSamples": "Tarefa de Análise - Tempo, Executor, Número de Amostras",
  "analysisTasks": "tarefas de análise",
  "analysisTasksToBundle": "Tarefas de Análise para Agrupar",
  "analysisTimePercentage": "Percentagem do tempo de análise em relação ao tempo total (A2T)",
  "anywhere": "Em qualquer lugar",
  "apiToken": "Token API",
  "archiveMember": "Arquivar Membro",
  "archived": "arquivado",
  "areYouSureConnection": "Tem a certeza que deseja esta ligação?",
  "areYouSureConnectionMode": "Tem a certeza que deseja entrar no modo \"com ligação\"? Isto irá remover todas as ligações atuais",
  "areYouSureDeleteAdmin": "Tem a certeza que deseja eliminar este administrador?",
  "areYouSureDiscardSimulation": "Tem a certeza que deseja descartar as alterações feitas no modo de simulação?",
  "areYouSurePublishSimulation": "Tem a certeza que deseja publicar as alterações feitas no modo de simulação?",
  "areYouSureReset": "Tem a certeza que deseja repor? Isto irá remover todos os nós.",
  "areYouSureUnplanAllFutureActions": "Tem a certeza que deseja desplanear todas as ações futuras neste projeto?",
  "areYouSureWantToExit": "Tem a certeza que deseja sair?",
  "arrival": "Chegada",
  "assetAddedOrRemoved": "Um ativo foi adicionado ou removido",
  "assetRequirementsForAsset": "Requisitos de Ativo para o Ativo {{index}}",
  "assets": "Ativos",
  "atLeast1LowercaseLetter": "pelo menos 1 letra minúscula",
  "atLeast1Number": "pelo menos 1 número",
  "atLeast1UppercaseLetter": "pelo menos 1 letra maiúscula",
  "atLeast8Characters": "pelo menos 8 caracteres",
  "automaticImportConversionSheet": "Folha de Conversão de Importação Automática de {{type}}",
  "automaticSheetConfiguration": "Configuração Automática de Folha",
  "availability": "Disponibilidade",
  "availableTimeOneWeek": "Tempo disponível por semana: ",
  "avgAnalysisDuration": "Duração média da análise: ",
  "avgSampleBatchInterval": "Intervalo médio do lote de amostras: ",
  "avgSamplesAllocated": "Número médio de amostras alocadas: ",
  "backlog": "Trabalho Pendente",
  "booked": "Reservado",
  "bookedBy": "Reservado por",
  "byCompetenceGroup": "Por Grupo de Competências",
  "byDeadline": "Por Prazo",
  "byGroup": "Por Grupo",
  "byText": "Por Texto",
  "canBePerformedAnywhere": "Pode ser realizado em qualquer lugar",
  "canOnlyBePerformedOnSite": "Só pode ser realizado no local",
  "cancel": "Cancelar",
  "cancelChanges": "Cancelar Alterações",
  "cannotUnlockStartedTasks": "Não pode desbloquear isto pois uma ou mais tarefas estão iniciadas/pausadas/concluídas",
  "changeLogs": "Registos de Alterações",
  "changesHaveBeenMade": "Foram feitas alterações, recarregue para obter novos dados",
  "chatbotGreeting": "Olá, sou o seu CHATBOT de IA, especializado na documentação de ajuda do Plannertech e Librarian, e nos repositórios de dados que importou.\nTambém pode sempre contactar o nosso Suporte Humano em pt@arnvind.com das 9 às 16 CET.\nComo posso ajudá-lo? :-)",
  "chatbotName": "Nome do Chatbot",
  "chatbotPlaceholder": "Escreva uma breve descrição sobre como o chatbot deve se comportar.",
  "chatbots": "Chatbots",
  "chattingWith": "A conversar com {{name}}",
  "chooseAction": "Escolher Ação",
  "chooseTask": "Escolher Tarefa",
  "chooseWhatToAdd": "Escolha o que adicionar",
  "cleanUp": "Limpar",
  "clear": "Limpar",
  "clearConversation": "Limpar a conversa",
  "clearDates": "Limpar Datas",
  "clearTable": "Limpar Tabela",
  "clickToSelectOtherFiles": "Clique para selecionar outros ficheiros",
  "close": "Fechar",
  "closeMessage": "fechar mensagem",
  "closePanel": "Fechar painel",
  "collaborator": "Colaborador",
  "collaborators": "Colaboradores",
  "domain": "Domínio",
  "color": "Cor",
  "columnName": "Nome da Coluna",
  "companyWideChatbot": "Chatbot para toda a empresa",
  "competenceAndInstrumentConstraints": "Restrições de Competências e Instrumentos",
  "competenceGroup": "Grupo de Competências",
  "competenceGroupNameExists": "Já existe um grupo de competências com esse nome",
  "competenceGroups": "Grupos de Competências",
  "competenceGroupsColon": "Grupos de Competências: ",
  "configuration": "Configuração",
  "confirm": "Confirmar",
  "confirmArchivalOfMember": "Confirmar arquivamento do membro: {{initials}}",
  "confirmClearTable": "Tem a certeza que deseja limpar a tabela?",
  "confirmDeleteAllData": "Ao confirmar, todos os dados de {{type}} serão eliminados. Não há volta atrás, mesmo com o Modo de Simulação.",
  "confirmDeleteAllUnplannedProjects": "Ao confirmar, todos os projetos que não têm ações no plano serão eliminados",
  "confirmDeleteAllUnplannedSamples": "Ao confirmar, todas as amostras que não têm ações no plano serão eliminadas",
  "confirmDeleteCompetenceGroup": "Confirmar eliminação do grupo de competências:",
  "confirmDeleteInstrument": "Tem a certeza que deseja eliminar o instrumento: {{name}}?",
  "confirmDeleteMaintenance": "Tem a certeza que deseja eliminar esta manutenção?",
  "confirmDeleteSample": "Tem a certeza que deseja eliminar esta amostra não planeada?",
  "confirmDeleteSampleInfo": "Ao confirmar, a amostra selecionada será eliminada permanentemente",
  "confirmDeletion": "Confirmar eliminação",
  "confirmFailSamples": "Tem a certeza que deseja reprovar as amostras selecionadas?",
  "confirmFailSamplesInfo": "Ao confirmar, as amostras selecionadas serão reprovadas. Uma cópia será colocada no menu de análises não planeadas",
  "confirmFailSamplesQuestion": "Tem a certeza que deseja reprovar as amostras selecionadas?",
  "confirmShowPlannedSamplesInfo": "Ao confirmar, as amostras planeadas serão mostradas",
  "confirmShowPlannedSamplesQuestion": "Tem a certeza que deseja mostrar as amostras planeadas?",
  "confirmSortByTime": "Tem a certeza que deseja ordenar por tempo",
  "confirmUnplanAllFutureActions": "Tem a certeza que deseja desplanear todas as ações futuras neste projeto?",
  "confirmUnplanAllQuestion": "Tem a certeza que deseja desplanear todos os {{itemType}}?",
  "confirmUnplanSamplesInfo": "Ao confirmar, as amostras selecionadas serão desplaneadas. Serão colocadas no menu de análises não planeadas",
  "confirmUnplanSamplesQuestion": "Tem a certeza que deseja desplanear as amostras selecionadas?",
  "connectionCalculatedInWorkdays": "Ligação calculada em dias úteis",
  "connectionCount": "Número de Ligações",
  "connections": "Ligações",
  "connectionsAdvancedWarning": "(A utilização de ligações com prazo ou início mais cedo em ações é para utilizadores avançados)",
  "connectionsPerformersOnly": "As ligações são apenas para executores — não afeta a alocação de ativos",
  "contactArnvindSupport": "Por favor contacte o suporte da Arnvind em pt@arnvind.com",
  "conversionSheet": "Folha de Conversão",
  "copyToClipboard": "copiar para a área de transferência",
  "country": "País",
  "create": "Criar",
  "createANewColumn": "Criar uma nova Coluna",
  "createAction": "Criar Ação",
  "createChatbot": "Criar chatbot",
  "createEditChatbots": "Criar/editar chatbots",
  "createEditRepositories": "Criar/editar repositórios",
  "createNewColumn": "Criar uma nova Coluna",
  "createNewProject": "Criar Novo Projeto",
  "createSingleAction": "Criar Ação Individual",
  "createStage": "Criar Fase",
  "createStandardAction": "Criar Ação Padrão",
  "currentlyProcessingRepository": "A processar este repositório atualmente",
  "daily": "Diário",
  "date": "Data",
  "dateUnavailable": "Data Indisponível",
  "day": "dia",
  "dayS": "dia(s)",
  "days": "dia(s)",
  "daysBeforeExpirationWarning": "Dias antes do vencimento para mostrar aviso",
  "daysBetweenRecurrences": "Dias Entre Recorrências",
  "deadline": "Prazo",
  "deadlineColon": "Prazo: ",
  "deadlineDate": "Data de prazo",
  "deadlineMustBeLaterThanEarliestStart": "O prazo deve ser posterior ou igual ao início mais cedo",
  "deadlineTime": "Hora do Prazo",
  "defaultChatbot": "Chatbot predefinido",
  "delete": "Eliminar",
  "deleteAllTypeTestData": "Eliminar todos os dados de teste de {{type}}",
  "deleteAllUnplannedProjects": "Eliminar todos os Projetos Não Planeados",
  "deleteAllUnplannedSamples": "Eliminar todas as Amostras Não Planeadas",
  "deleteColumn": "Eliminar Coluna",
  "deleteCompetenceGroup": "Eliminar Grupo de Competências",
  "deleteCompetenceGroupWarning": "Ao eliminar, as tarefas nas seguintes análises ficarão sem Grupo de Competências. Certifique-se de substituir antes de remover.",
  "deleteConstraint": "Eliminar restrição",
  "deleteData": "Eliminar Dados",
  "deleteInstrument": "Eliminar Instrumento",
  "deleteInstrumentWarning": "Também será eliminado para outras equipas neste local.",
  "deleteProjects": "Eliminar Projetos",
  "deleteSample": "Eliminar Amostra",
  "deleteSamples": "Eliminar Amostras",
  "deleteThisRow": "Eliminar esta linha",
  "description": "Descrição",
  "designTool": "Ferramenta de Design",
  "done": "Concluído",
  "draft": "rascunho",
  "dragAndDropFiles": "Arraste e largue ficheiros aqui, ou clique para selecionar ficheiros",
  "dragAndDropFolders": "Arraste e largue pastas aqui, ou clique para selecionar ficheiros específicos",
  "dropFilesHere": "Solte os ficheiros aqui",
  "dropFoldersHere": "Largue as pastas aqui...",
  "duplicate": "Duplicar",
  "durationHHMM": "Duração (HH:MM)",
  "earliestStart": "Início Mais Cedo",
  "edit": "Editar",
  "editAction": "Editar Ação",
  "editAdmin": "Editar Administrador",
  "editAnalysisGroup": "Editar grupo de análise",
  "editAnalysisTask": "Editar Tarefa de Análise",
  "editChatbot": "Editar chatbot",
  "editCompetenceGroup": "Editar Grupo de Competências",
  "editConnectionFromTo": "Editar ligação de {{from}} para {{to}}",
  "editConversation": "Editar Conversa",
  "editGroup": "Editar grupo",
  "editInstrument": "Editar Instrumento",
  "editItem": "Editar {{item}}",
  "editLocationName": "Editar nome da localização",
  "editMaintenanceFor": "Editar {{name}} para {{assetName}}",
  "editMember": "Editar membro",
  "editOffsite": "Editar FORA DO LOCAL",
  "editProject": "Editar Projeto",
  "editProjectGroup": "Editar grupo de projetos",
  "editProjectTemplate": "Editar Modelo de Projeto",
  "editProjectTemplateDraft": "Editar RASCUNHO de Modelo de Projeto",
  "editRepository": "Editar repositório",
  "editSampleName": "Editar amostra: {{name}}",
  "editSheet": "Editar Folha {{name}}",
  "editStandardAction": "Editar Ação Padrão",
  "editTask": "Editar tarefa",
  "editTeam": "Editar equipa",
  "edited": "Editado",
  "email": "e-mail",
  "emailCannotContainDoubleDots": "O email não pode conter '..'",
  "emailLabel": "Email",
  "endDate": "Data de fim",
  "enterSimulationMode": "Entrar no Modo de Simulação",
  "errors": "Erros",
  "errorsProcessingRepository": "Ocorreram erros ao processar este repositório",
  "estimatedWorkloadOneWeek": "Carga de trabalho estimada por semana: ",
  "exclusive": "Exclusivo",
  "exclusiveSampleIndicator": "* Indica uma amostra exclusiva",
  "exitSimulation": "SAIR DA SIMULAÇÃO",
  "exitSimulationMode": "Sair do modo de simulação",
  "expand": "Expandir",
  "exportToExcel": "Exportar para Excel",
  "fail": "Reprovar",
  "failSample": "Reprovar Amostra",
  "failSelected": "Reprovar Selecionados",
  "failedLoading": "Falha ao carregar: {{members}}",
  "failedToCreateMaintenance": "Falha ao criar manutenção \"{{name}}\"",
  "failedToDeleteMaintenance": "Falha ao eliminar manutenção \"{{name}}\"",
  "failedToMarkMaintenanceAsCompleted": "Falha ao marcar manutenção \"{{name}}\" como concluída",
  "failedToUpdateMaintenance": "Falha ao atualizar manutenção \"{{name}}\"",
  "failedUploads": "Envios Falhados",
  "fileUpload": "Envio de Ficheiro",
  "fileUploadError": "Ocorreu um erro durante o envio do ficheiro",
  "filenameLabel": "Nome do ficheiro: ",
  "filesUploadedSuccessfully": "Ficheiros enviados com sucesso",
  "fillIn": "Preencher",
  "fillInIgnoreOverbooking": "Preencher Ignorando Reserva Excessiva",
  "filter": "Filtrar",
  "filterByName": "Filtrar por Nome",
  "filterBySampleName": "Filtrar por Nome de Amostra",
  "filterBySampleProductName": "Filtrar por Nome de Amostra/Produto",
  "filterByText": "Filtrar por Texto",
  "finished": "Concluído",
  "flag": "Assinalar",
  "flagSample": "Assinalar Amostra",
  "followingErrorsWhileImporting": "Os seguintes erros durante a importação:",
  "free": "Livre",
  "from": "De",
  "fromDate": "Da data",
  "fromTime": "Da hora (HH:MM)",
  "fromTimeHH": "Da hora (HH)",
  "fromTimeHHMM": "Da hora (HH:MM)",
  "futureAnalysisTaskCantBe": "Uma tarefa de análise futura não pode ser {{state}}",
  "generate": "Gerar",
  "globalChatbot": "Chatbot global",
  "goBack": "Voltar",
  "goBackToChat": "Voltar ao chat",
  "greyTaskTimePercentage": "Percentagem do tempo de tarefa cinza em relação ao tempo total (G2T)",
  "groupMembers": "Membros do Grupo",
  "groupName": "Nome do Grupo",
  "help": "Ajuda",
  "helpBackToApp": "Voltar ao app",
  "helpHome": "Página inicial da ajuda",
  "helpPageNotFound": "Página de ajuda não encontrada",
  "helpSearch": "Pesquisar ajuda",
  "helpAppTitle": "Ajuda Plannertech",
  "hidden": "Oculto",
  "hideMore": "Ocultar mais",
  "highestPriority": "1 é a prioridade mais alta",
  "history": "Histórico",
  "home": "Início",
  "hour": "hora",
  "iCalendarOutlookIntegration": "Integração iCalendar / Outlook",
  "iap": "IAP",
  "ignoreAllGreytasks": "Ignorar Todas as Tarefas Cinza",
  "ignoredByIap": "Ignorado pelo IAP",
  "includingToday": "Incluindo hoje",
  "importedTask": "Tarefa importada",
  "busyOnAnotherTeam": "Ocupado em outra equipe",
  "includeDoneSamples": "Incluir amostras concluídas",
  "includeOverdue": "Incluir Atrasados",
  "includeToday": "Incluir Hoje",
  "iapIncludeTodayWarningIAP": "Aviso IAP e Incluir Hoje — tarefas planeadas anteriormente hoje também podem ser movidas a menos que estejam bloqueadas!",
  "iapIncludeTodayWarningFillIn": "Aviso Preencher e Incluir Hoje — tarefas planeadas anteriormente hoje também podem receber novas amostras alocadas!",
  "initials": "Iniciais",
  "inputLastMonth": "Entrada do Mês Passado",
  "inputThisMonth": "Entrada deste Mês",
  "instrument": "Instrumento",
  "instrumentConstraints": "Restrições de Instrumento",
  "instrumentLog": "Registo do Instrumento",
  "instrumentName": "Nome do Instrumento",
  "instrumentOffset": "Desvio do instrumento (HH:MM)",
  "instrumentOverbooking": "Reserva Excessiva de Instrumento",
  "instrumentPerSampleDuration": "Duração do instrumento por amostra (HH:MM:SS)",
  "instrumentSetup": "Configuração do Instrumento {{name}}",
  "instrumentSetuptime": "Tempo de configuração do instrumento (HH:MM)",
  "instrumentTime": "Tempo do Instrumento",
  "instrumentView": "Vista do Instrumento",
  "instruments": "Instrumentos",
  "instrumentsWithExpiredMaintenance": "Existem instrumentos com manutenção expirada",
  "instrumentsWithMaintenanceReminders": "Existem instrumentos com lembretes de manutenção",
  "integration": "Integração",
  "invalidDate": "Data Inválida",
  "invalidOutlookLink": "Ligação iCalendar / Outlook inválida",
  "isInSimulationMode": "{{initials}} está no modo de simulação",
  "isSimulating": "{{initials}} está a simular...",
  "keepExistingConnections": "Manter ligações existentes",
  "labelAlreadyLoaded": "Já carregado: {{count}}",
  "labelCreated": "Criado: {{count}}",
  "labelDeleted": "Eliminado: {{count}}",
  "labelDeletedOrFinished": "Eliminado ou marcado como concluído: {{count}}",
  "labelDoneDeleted": "Concluído/Eliminado: {{count}}",
  "labelUpdatedInformation": "Informação atualizada: {{count}}",
  "lastErrorLog": "Último Registo de Erros",
  "lastWeek": "Semana Passada",
  "latestArrival": "Última Chegada",
  "leadTimesInWorkDays": "Prazos de Entrega em Dias Úteis",
  "leaveEmptyIfNotUsed": "(deixe vazio se não for utilizado)",
  "leaveEmptyIfNotUsedDefault": "(deixe vazio se não for utilizado, predefinição={{defaultValue}})",
  "loadFromTemplate": "Carregar de modelo",
  "loading": "A CARREGAR",
  "loadingEllipsis": "A carregar...",
  "loadingSamples": "A carregar amostras",
  "loadingSheet": "A carregar folha",
  "loadingSheets": "A carregar folhas",
  "location": "Localização",
  "locationColon": "Localização: {{name}}",
  "locationName": "Nome da Localização",
  "lockItemType": "Bloquear {{itemType}}",
  "lockSamples": "Bloquear amostras",
  "lockUnlockSamplesLabel": "Bloquear/Desbloquear amostras:",
  "locks": "Bloqueios",
  "locksAllFutureAnalysisTasks": "Bloqueia todas as tarefas de análise planeadas futuras",
  "locksAllFutureProjectActions": "Bloqueia todas as ações de projeto planeadas futuras",
  "login": "Iniciar sessão",
  "logout": "Terminar sessão",
  "maintenanceCreatedSuccessfully": "Manutenção \"{{name}}\" criada com sucesso",
  "maintenanceDeletedSuccessfully": "Manutenção \"{{name}}\" eliminada com sucesso",
  "maintenanceExpired": "Manutenção expirada",
  "maintenanceExpiresInDays": "A manutenção expira em menos de {{days}} dias",
  "maintenanceMarkedAsCompleted": "Manutenção \"{{name}}\" marcada como concluída",
  "maintenanceName": "Nome da manutenção",
  "maintenanceUpdatedSuccessfully": "Manutenção \"{{name}}\" atualizada com sucesso",
  "mandatoryIfRecurrenceUsed": "(obrigatório se a recorrência for utilizada)",
  "manualSample": "Amostra manual",
  "manualSheetConfiguration": "Configuração Manual de Folha",
  "markAsDone": "Marcar como concluído",
  "maxSampleCount": "Número Máximo de Amostras",
  "maxSampleCountLabel": "Núm. máximo de amostras: ",
  "maxTimeBetweenActions": "Tempo máximo entre ações (DD:HH:MM)",
  "maxTimeBetweenTasks": "Tempo máximo entre tarefas (DD:HH:MM)",
  "member": "Membro",
  "memberHasEnabledICalendarOutlookIntegration": "O Membro Ativou a Integração iCalendar / Outlook",
  "memberHasEnabledOutlook": "O Membro Ativou a Integração iCalendar / Outlook",
  "memberPermissions": "Permissões do membro",
  "memberPlan": "Plano do Membro",
  "memberTime": "Tempo do Membro",
  "membersGoDirectlyToMemberPlan": "Os membros vão diretamente para o plano do membro",
  "message": "Mensagem",
  "metric": "Métrica",
  "minSampleCount": "Número Mínimo de Amostras",
  "minSampleMustBeLowerThanMax": "O número mínimo de amostras deve ser inferior ao número máximo",
  "minTimeBetweenActions": "Tempo mínimo entre ações (DD:HH:MM)",
  "minTimeBetweenTasks": "Tempo mínimo entre tarefas (DD:HH:MM)",
  "minTimeMustBeSmallerThanMax": "O tempo mínimo entre deve ser inferior ao tempo máximo entre",
  "minimumDuration": "Duração Mínima: {{time}}",
  "minute": "minuto",
  "missingPasswordRequirements": "Requisitos de palavra-passe em falta: {{requirements}}",
  "months": "Meses",
  "movedBy": "Movido Por",
  "movedFrom": "Movido De",
  "movedTo": "Movido Para",
  "mustBeIcsLink": "Deve ser uma ligação .ics",
  "name": "Nome",
  "namePerformer": "Executor {{name}}",
  "nameTooLongTitle": "Nome demasiado longo (máximo 100 caracteres)",
  "newAnalysisTaskBundle": "Novo Pacote de Tarefa de Análise",
  "newChat": "Nova conversa",
  "newInstrument": "Novo Instrumento",
  "newProject": "Novo Projeto",
  "newProjectTemplateDraft": "RASCUNHO de Novo Modelo de Projeto",
  "newStart": "Novo Início",
  "nextDay": "Dia Seguinte",
  "nextWeek": "Semana Seguinte",
  "no": "Não",
  "noAnalysesForProduct": "Não foram encontradas análises para este produto.",
  "noAssetsFound": "Não foram encontrados ativos",
  "noChanges": "Sem alterações",
  "noChatbotSelected": "Nenhum chatbot selecionado",
  "noDataFound": "Nenhum dado encontrado",
  "noErrorsToDisplay": "Não há erros para mostrar.",
  "noGroup": "Sem grupo",
  "noMembersLoaded": "Nenhum membro foi carregado.",
  "noOfRecurrences": "Núm. de Recorrências",
  "noReferencesAvailable": "Não há referências disponíveis.",
  "noSamples": "Sem amostras",
  "noSamplesAvailable": "Não há amostras disponíveis",
  "noSearchResults": "Sem resultados de pesquisa",
  "noTimeLimitUnlessSpecified": "Sem limite de tempo, a menos que especificado",
  "none": "Nenhum",
  "default": "Predefinição",
  "notAvailable": "N/D",
  "notEnoughRoomForDuration": "Não há espaço suficiente para a duração",
  "notStarted": "Não Iniciado",
  "numberOfObservations": "Número de Observações",
  "numberOfRecurrences": "Número de recorrências",
  "numericInputBetweenTimeRange": "Por favor introduza um valor numérico entre 00:00 e 23:59",
  "offsiteCalendar": "Calendário FORA DO LOCAL",
  "ok": "Ok",
  "oldInstrument": "Instrumento Antigo",
  "oldStart": "Início Anterior",
  "onlyAdvancedUsersInfo": "Apenas utilizadores avançados usam tanto o início mais cedo como as ligações",
  "onsite": "No local",
  "openReferences": "Abrir Referências",
  "operationalGreyTaskTimePercentage": "Percentagem do tempo de tarefa cinza operacional em relação ao tempo total (OG2T)",
  "operationalTask": "Tarefa Operacional",
  "otherPlannerSimulating": "{{initials}} está no modo de simulação",
  "outlookLinkLabel": "Ligação iCalendar / Outlook",
  "outputLastMonth": "Saída do Mês Passado",
  "outputThisMonth": "Saída deste Mês",
  "parentColumn": "Coluna Principal",
  "password": "Palavra-passe",
  "paused": "Pausado",
  "peopleSetup": "Configuração de Pessoas",
  "perSampleDuration": "Duração por amostra (HH:MM:SS)",
  "perSampleDurationForPeopleSetup": "Duração Por Amostra para Configuração de Pessoas",
  "performerConstraintsCount": "Número de Restrições de Executor",
  "performerConstraintsLabel": "Restrições de Executor",
  "permanentApiToken": "Token API permanente",
  "permanentApiTokenDescription": "Este é um token API permanente que lhe permite aceder à sua equipa através da nossa API. Copie-o e guarde-o num local seguro.",
  "pinConversation": "Fixar conversa",
  "planned": "Planeado",
  "planner": "Planeador",
  "plannertechLanguage": "Idioma do Plannertech",
  "plannertechVariable": "Variável do Plannertech",
  "pleaseChooseColor": "Por favor escolha uma Cor para a análise",
  "pleaseFillOutAnalysisName": "Por favor preencha o Nome da Análise",
  "pleaseFillOutRequiredTaskParams": "Por favor preencha os parâmetros de tarefa obrigatórios",
  "pleaseGiveEmptyOrFullInput": "Por favor forneça uma entrada vazia ou completa",
  "pleaseGiveNumericInput": "Por favor forneça uma entrada numérica",
  "pleaseInputValidDate": "Por favor introduza uma data válida",
  "pleaseSelectAtLeastOneItem": "Por favor selecione pelo menos um item",
  "pleaseSelectColor": "Por favor selecione uma cor",
  "pleaseSelectFirstDay": "Por favor selecione o primeiro dia.",
  "pleaseSelectLastDay": "Por favor selecione o último dia.",
  "pleaseSelectTimezone": "Por favor selecione um fuso horário",
  "previousDay": "Dia Anterior",
  "primary": "Principal",
  "primaryInstrument": "Instrumento Principal",
  "prioritizeByDeadline": "Priorizar IAP por Prazo",
  "prioritizeByPriority": "Priorizar IAP por Número de Prioridade",
  "priority": "Prioridade",
  "priorityHigh": "(Alta)",
  "priorityLow": "(Baixa)",
  "priorityMedium": "(Média)",
  "process": "Processo",
  "processed": "Processado",
  "processing": "A processar...",
  "processingInProgress": "A processar",
  "productName": "Nome do Produto",
  "project": "Projeto",
  "projectActions": "ações do projeto",
  "projectBatchNumber": "Número de Lote do Projeto",
  "projectDeadline": "Prazo do Projeto",
  "projectDescription": "Descrição do Projeto",
  "projectEarliestStart": "Início Mais Cedo do Projeto",
  "projectGroup": "Grupo de projetos",
  "projectGroupName": "Nome do Grupo de Projetos",
  "projectImport": "Importação de Projeto",
  "projectImportVariable": "Variável de Importação de Projeto",
  "projectMaterialDescription": "Descrição do Material do Projeto",
  "projectMaterialNumber": "Número do Material do Projeto",
  "projectName": "Nome do Projeto",
  "projectPriority": "Prioridade do Projeto",
  "projectReleaseDate": "Data de Lançamento do Projeto",
  "projectSupplierName": "Nome do Fornecedor do Projeto",
  "projectSupplierNumber": "Número do Fornecedor do Projeto",
  "projectTemplate": "modelo de projeto",
  "projectTemplates": "Modelos de Projeto",
  "projectTimePercentage": "Percentagem do tempo do projeto em relação ao tempo total (P2T)",
  "projectView": "Vista do Projeto",
  "projects": "Projetos",
  "projectsAndActions": "Projetos e Ações",
  "promptPrefix": "Prefixo do Prompt",
  "promptTooLongTitle": "Prompt demasiado longo (máximo 1200 caracteres)",
  "publish": "PUBLICAR",
  "publishSimulationChanges": "Publicar alterações do modo de simulação",
  "qcLibrarian": "QC Librarian",
  "qcLibrarianTitle": "QC Librarian 3.8",
  "recur": "Recorrência",
  "recurEvery": "Repetir a cada",
  "recurrence": "Recorrência",
  "reduce": "Reduzir",
  "references": "Referências",
  "rejectedFileTypes": "Tipos de Ficheiro Rejeitados",
  "rejectedFilesIncompatible": "Os seguintes ficheiros foram rejeitados devido a formatos incompatíveis",
  "reminderDaysBeforeEndDate": "Lembrete (dias antes da data de fim)",
  "remove": "Remover",
  "removeAnalysisFromProduct": "Remover {{name}} deste produto",
  "removeAsset": "Remover Ativo",
  "removeEverything": "Remover tudo",
  "removeInstrument": "Remover Instrumento",
  "reportGenerator": "Gerador de Relatórios",
  "reports": "Relatórios",
  "repositories": "Repositórios",
  "repositoryCurrentlyProcessing": "O repositório está a processar os ficheiros. Por favor atualize a página para ver o progresso",
  "repositoryHasUnprocessedFiles": "Este repositório tem ficheiros não processados",
  "repositoryIsProcessed": "Este repositório foi processado",
  "repositoryName": "Nome do Repositório",
  "reset": "Repor",
  "role": "Função",
  "row": "Linha",
  "rowNumber": " linha {{row}}",
  "runIAP": "Executar IAP",
  "runningIAP": "A executar IAP",
  "sampleAnalysisName": "Nome da Análise de Amostra",
  "sampleBatchNumber": "Número de Lote de Amostra",
  "sampleHighestPriority": "A amostra tem a prioridade mais alta",
  "sampleId": "ID da Amostra",
  "sampleIdWithValue": "ID da Amostra: {{id}}",
  "sampleImport": "Importação de Amostra",
  "sampleImportVariable": "Variável de Importação de Amostra",
  "sampleInProgressOnDoneAnalysis": "Amostra em progresso numa análise concluída",
  "sampleIsDone": "A amostra está concluída",
  "sampleLog": "Registo da Amostra",
  "sampleLowestPriority": "A amostra tem a prioridade mais baixa",
  "sampleMaterialNumber": "Número do Material da Amostra",
  "sampleName": "Nome da Amostra",
  "sampleObservation": "Observação da Amostra",
  "sampleObservations": "Observações da Amostra",
  "samplePercentage": "Percentagem de amostra",
  "sampleProductDescription": "Descrição do Produto da Amostra",
  "sampleReceivedDate": "Data de Receção da Amostra",
  "sampleStatus": "Estado da Amostra",
  "sampleView": "Vista da Amostra",
  "samples": "Amostras",
  "samplesWithName": "Amostras com o nome {{name}}",
  "samplesWithoutProduct": "Amostras sem produto",
  "save": "Guardar",
  "saveAs": "Guardar Como",
  "saveAsDraft": "Guardar como RASCUNHO de {{type}}",
  "saveAsNew": "Guardar como novo",
  "saveAsNewAnalysis": "Guardar como nova análise",
  "saveAsNewTemplate": "Guardar como novo modelo",
  "saveAsType": "Guardar como {{type}}",
  "scrollToTop": "Deslocar para o topo",
  "scrumView": "Vista Scrum",
  "scrumViewOrdering": "Ordenação da Vista Scrum",
  "searchBySampleName": "Pesquisar por nome de amostra...",
  "searchCountry": "Pesquisar país",
  "seats": "Lugares",
  "second": "segundo",
  "secondaryInstrumentMustHaveAllowedInstrument": "A configuração do instrumento secundário deve ter pelo menos um instrumento permitido",
  "selectAll": "Selecionar Tudo",
  "selectChatbot": "Selecionar chatbot",
  "selectDefaultChatbot": "Selecionar chatbot predefinido",
  "selectEntireDay": "Selecionar o dia inteiro",
  "selectEntireWorkday": "Selecionar o dia de trabalho inteiro",
  "selectLocation": "Selecionar localização...",
  "selectSamples": "Selecionar Amostras",
  "selectState": "Selecionar estado...",
  "selectTimezone": "Selecionar fuso horário...",
  "selectType": "Selecionar Tipo",
  "selectedFilesReadyForSubmit": "Ficheiros/pastas selecionados prontos para enviar:",
  "selectedProduct": "Produto Selecionado",
  "setPlannedValues": "Definir Valores Planeados",
  "settings": "Definições",
  "settingsForQcLibrarian": "Definições para QC Librarian",
  "setupTimeForPeopleSetup": "Tempo de Configuração para Configuração de Pessoas",
  "setuptime": "Tempo de configuração (HH:MM)",
  "sheetName": "Nome da Folha",
  "sheetNameLabel": "Nome da Folha",
  "sheetType": "Tipo de Folha",
  "shouldBeEqualTo": "deve ser igual a",
  "shouldNotBeEqualTo": "não deve ser igual a",
  "showAnalyses": "Mostrar Análises",
  "showErrors": "Mostrar Erros",
  "showLastErrorLog": "Mostrar último registo de erros",
  "showLibrarian": "Mostrar Librarian",
  "showLog": "Mostrar Registo",
  "showMore": "Mostrar mais",
  "showOnPlan": "Mostrar no Plano",
  "showProjects": "Mostrar Projetos",
  "shown": "Visível",
  "simulationMode": "Modo de Simulação",
  "simulationModeLogoutWarning": "Está atualmente no modo de simulação. Terminar a sessão irá descartar as alterações!",
  "simulationModeOccupied": "MODO DE SIMULAÇÃO OCUPADO",
  "simulationModeUpper": "MODO DE SIMULAÇÃO",
  "somethingWentWrong": "Algo correu mal",
  "sortByProduct": "Ordenar por produto",
  "sortByTime": "Ordenar Por Tempo",
  "sortByTimeDescription": "Ordena as ações de Trabalho Pendente e A Fazer pelos seus prazos, e as Planeadas e Concluídas pelo seu tempo de início",
  "speechToTextLanguage": "Idioma de voz para texto",
  "spreadsheetColumnName": "Nome da Coluna da Folha de Cálculo",
  "stage": "Fase",
  "standardActions": "Ações Padrão",
  "start": "Iniciar",
  "startDate": "Data de Início",
  "startDateCheckboxInfo": "Quando marcado, o prazo do projeto, o prazo da ação e o início da ação serão movidos em relação ao início do projeto",
  "startEndDate": "Data de Início/Fim",
  "startProcessingInfo": "Isto irá iniciar o processamento do repositório. Pode demorar algum tempo dependendo do tamanho do repositório",
  "startRecurrence": "Iniciar Recorrência",
  "startTime": "Hora de Início",
  "started": "Iniciado",
  "state": "Estado",
  "status": "Estado",
  "submit": "Submeter",
  "successfullyLoaded": "Carregado com sucesso: {{members}}",
  "successfullyUploadedFiles": "Ficheiros Enviados com Sucesso",
  "systemPrompt": "Prompt do sistema",
  "taskBelongsToTeam": "A tarefa pertence à equipa: {{team}}",
  "taskCount": "Número de Tarefas",
  "taskDesignTool": "Ferramenta de Design de Tarefas",
  "taskLog": "Registo de Tarefas",
  "taskName": "Nome da Tarefa",
  "taskPerformerConstraints": "Restrições de Executor de Tarefa",
  "tasks": "Tarefas",
  "team": "Equipa",
  "teamChatbot": "Chatbot da equipa",
  "teamLabel": "Equipa: {{name}}",
  "teamMember": "Membro da Equipa",
  "teamName": "Nome da Equipa",
  "teamPlan": "Plano da Equipa",
  "teamUsageTitle": "Utilização de {{name}}",
  "teams": "Equipas",
  "templateIsDraft": "Este modelo de projeto é um Rascunho",
  "templateName": "Nome do Modelo",
  "theProjectIsDone": "O projeto está concluído",
  "timeConstraints": "Restrições de Tempo",
  "timeHHMM": "Hora (HH:MM)",
  "timePeriod": "Período de Tempo",
  "timestamp": "Data e Hora",
  "timezone": "Fuso Horário",
  "to": "Para",
  "toConfirmDeletionType": "Para confirmar a eliminação escreva {{keyword}}",
  "toConfirmDeletionTypeDeleteData": "Para confirmar a eliminação escreva {{keyword}} e prima confirmar. Isto irá eliminar permanentemente os dados de teste, mesmo com o modo de simulação. Não há volta atrás.",
  "toConfirmDeletionTypeKeyword": "Para confirmar a eliminação escreva {{keyword}} e prima confirmar",
  "toDate": "Até à data",
  "toDo": "A Fazer",
  "toTime": "Até à hora (HH:MM)",
  "toTimeHH": "Até à hora (HH)",
  "toTimeHHMM": "Até à hora (HH:MM)",
  "today": "Hoje",
  "tokens": "Tokens",
  "total": "Total",
  "normalSeats": "Normal",
  "tryReloadingOrContactSupport": "Tente recarregar, ou contacte o suporte se o problema persistir!",
  "type": "Tipo",
  "typeBeforeConfirming": "escreva {{keyword}} antes de confirmar",
  "typeOrSelect": "Escreva ou selecione...",
  "typeYourMessage": "Escreva a sua mensagem...",
  "unassignedSamples": "Amostras não atribuídas",
  "unassignedSamplesFor": "Amostras não atribuídas para \"{{name}}\"",
  "unflag": "Remover assinalação",
  "unflagSample": "Remover Assinalação da Amostra",
  "unlockItemType": "Desbloquear {{itemType}}",
  "unlockSamples": "Desbloquear amostras",
  "unlocks": "Desbloqueios",
  "unlocksAllFutureAnalysisTasks": "Desbloqueia todas as tarefas de análise planeadas futuras",
  "unlocksAllFutureProjectActions": "Desbloqueia todas as ações de projeto planeadas futuras",
  "unnamed": "sem nome",
  "unpinConversation": "Desafixar conversa",
  "unplan": "Desplanear",
  "unplanAnalysis": "Desplanear Análise",
  "unplanItemType": "Desplanear {{itemType}}",
  "unplanSample": "Desplanear Amostra",
  "unplanSelected": "Desplanear Selecionados",
  "unplanned": "Não Planeado",
  "unplannedProjects": "Projetos Não Planeados",
  "unsavedChangesIn": "Há alterações não guardadas em:",
  "updateIntegration": "Atualizar Integração",
  "updatedIcalOutlook": "iCalendar / Outlook atualizado!",
  "uploadAborted": "Envio cancelado!",
  "uploadComplete": "Envio concluído!",
  "uploadFailedForFile": "O envio falhou para o ficheiro: {{path}}",
  "uploadFinished": "Envio Concluído!",
  "uploadTo": "Enviar para {{name}}",
  "usage": "Utilização",
  "used": "Utilizado",
  "usedAssets": "Ativos Utilizados",
  "usedInstrument": "Instrumento Utilizado",
  "usedInstruments": "Instrumentos Utilizados",
  "username": "Nome de utilizador",
  "value": "Valor",
  "view": "Ver",
  "viewAllAnalysesForProduct": "Ver todas as análises para este produto",
  "viewAnalysisSamples": "Ver Amostras de Análise",
  "viewCompact": "Vista Compacta",
  "viewNormal": "Vista Normal",
  "weekNumber": "Semana {{week}}",
  "weekView": "Vista Semanal",
  "dayView": "Vista Diária",
  "weekendView": "Vista de Fim de Semana",
  "screen": "Ecrã",
  "clickToSortBy": "Clique para ordenar por {{column}}",
  "fileChangedPleaseReselect": "{{file}} foi alterado. Por favor selecione o ficheiro novamente",
  "contentTooWideZoomOut": "O conteúdo é demasiado largo para o ecrã. Para uma melhor experiência, reduza o zoom ({{key}} +/-)",
  "week": "Semana",
  "weekly": "Semanal",
  "weeks": "semana(s)",
  "withConnections": "com ligações",
  "workHours": "Horas de Trabalho",
  "workWeek": "Semana de Trabalho",
  "years": "Anos",
  "yes": "Sim",
  "youAreInSimulationMode": "Está no modo de simulação",
  "zeroHours": "0 horas",
  "addCustomer": "Adicionar cliente",
  "addGlobalChatbot": "Adicionar chatbot global",
  "addGlobalRepository": "Adicionar repositório global",
  "apiKey": "Chave API",
  "authenticationCode": "Código de Autenticação",
  "authenticationCodeSentInfo": "Enviámos um código de autenticação para o seu email. Por favor introduza-o acima antes de iniciar sessão",
  "chatbotPrefix": "Prefixo do chatbot",
  "chatbotSystemPrompt": "Prompt do Sistema do Chatbot",
  "chatbotSystemPrompts": "Prompts do Sistema do Chatbot",
  "citationGuidelines": "Diretrizes de citação",
  "configureMember": "Configurar Membro",
  "createApiKey": "Criar chave API",
  "creatingProject": "A criar Projeto",
  "currentQuestion": "Pergunta atual",
  "customerAdminApiKeyForGlobalRepositories": "Chave API de Administrador do Cliente para Repositórios Globais",
  "dateFormatYyyyMmDd": "AAAA-MM-DD",
  "deleteApiKey": "Eliminar chave API",
  "descriptionPrompt": "Prompt de Descrição",
  "editGlobalMessage": "Editar Mensagem Global",
  "editingProject": "A editar Projeto",
  "editSystemPrompts": "Editar Prompts do Sistema",
  "filePathPrompt": "Prompt de Caminho do Ficheiro",
  "fillingInSamples": "A preencher amostras",
  "generalPrefix": "Prefixo geral",
  "globalChatbots": "Chatbots Globais",
  "globalRepositories": "Repositórios Globais",
  "hideNextWeek": "Ocultar Semana Seguinte",
  "hideSatSun": "- Sáb/Dom",
  "manageAdmins": "Gerir Administradores",
  "oneWeek": "1 Semana",
  "openMetricsPanel": "Abrir Painel de Métricas/IAP",
  "openTodoList": "Abrir Lista de Tarefas",
  "optimizedQuestionPrompt": "Prompt de pergunta otimizado",
  "plannertech": "Plannertech",
  "plannertechSuite": "Plannertech Suite",
  "plannertechTeamPlan": "Plano de Equipa Plannertech",
  "previousConversation": "Conversa anterior",
  "librarianLogoAlt": "Logótipo do Librarian",
  "qcLibrarianForCompany": "{{company}} QC Librarian",
  "relevantDocumentation": "Documentação relevante",
  "repositoryHasUnprocessedFilesInfo": "Existem ficheiros não processados neste repositório",
  "repositoryIsEmpty": "Este repositório está vazio",
  "repositoryPrefix": "Prefixo do repositório",
  "repositoryProcessingInProgressInfo": "O repositório está a processar os ficheiros. Por favor atualize a página para ver o progresso",
  "sampleAllocation": "Alocação de amostras",
  "mbWithValue": "{{value}} MB",
  "seatsWithCount": "Lugares: {{count}}",
  "excludingToday": "Excluindo hoje",
  "unplanning": "A desplanear",
  "activeSeats": "Lugares ativos: {{count}}",
  "totalSeats": "Lugares normais: {{count}}",
  "purchasedSeats": "Lugares adquiridos: {{count}}",
  "globalMessage": "Mensagem Global",
  "clearGlobalMessageConfirm": "Tem a certeza que deseja limpar a mensagem global? Isto fará com que desapareça para todos os utilizadores.",
  "samplesCount": "Amostras: {{count}}",
  "locations": "Localizações",
  "customers": "Clientes",
  "editCustomer": "Editar cliente",
  "addCustomerTitle": "Adicionar Cliente",
  "deleteCustomer": "Eliminar Cliente",
  "customerName": "Nome do Cliente",
  "customerStatus": "Estado do cliente",
  "active": "Ativo",
  "passive": "Passivo",
  "allowedDomains": "Domínios Permitidos",
  "allowedPerformers": "Executores permitidos",
  "seatsPurchased": "Lugares adquiridos",
  "customerApiKey": "Chave API do cliente",
  "durationFormatDDHH": "DD:HH",
  "durationFormatHHMMSS": "HH:MM:SS",
  "durationFormatHHMM": "HH:MM",
  "durationFormatHH": "HH",
  "durationFormatDDHHMM": "DD:HH:MM",
  "continue": "Continuar",
  "showNextWeek": "Mostrar Semana Seguinte",
  "showSatSun": "+ Sáb/Dom",
  "topDescriptionPrompt": "Prompt de descrição superior",
  "twoWeeks": "2 Semanas",
  "updateHelpPage": "Atualizar Página de Ajuda",
  "userAlreadyLoggedInTakeOver": "O utilizador já iniciou sessão. Para assumir a sessão prima confirmar",
  "zoomIn": "Ampliar",
  "zoomOut": "Reduzir",
  "constraintWarningTitle": "Ocorreram {{count}} aviso(s)",
  "assetStatusFree": "Livre",
  "assetStatusBooked": "Reservado",
  "dateTo": "até",
  "futureAnalysisTaskCantBeFinished": "Uma tarefa de análise futura não pode ser concluída",
  "tableNotFound": "Tabela não encontrada",
  "conversionSheetFilename": "Folha de Conversão.xlsx",
  "selectTeam": "Select a team to log in to",
  "admin": "Admin",
  "customerAdmin": "Admin do Cliente",
  "attachFile": "Anexar ficheiro",
  "removeFile": "Remover ficheiro",
  "fileTooLarge": "O ficheiro é demasiado grande (máx. 10 MB)",
  "tooManyFiles": "Máximo de 3 ficheiros por mensagem",
  "unsupportedFileType": "Tipo de ficheiro não suportado. Permitidos: PDF, DOCX, TXT, CSV, PNG, JPG, GIF, WEBP"
}
